import PubSub from "underpub-js";

var TeamMemberInformation = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-TeamMemberInformation',
	};

	$.extend(true, this.options, options);

};

TeamMemberInformation.prototype.init = function() {

	var self = this;

};

export default TeamMemberInformation;
